import React from 'react'

export default function ShippingPolicies() {

    // on hash click
    const handleHashUrlClick = (ev, hash) => {
        ev.preventDefault()
        if (hash) {
            const elem = document.getElementById(hash)

            // scrolling to element
            if (elem) {
                window.scrollTo(0, elem.offsetTop)
            }
        }
    }
    return (
        <div className="page-split-view">
            <div className="inner d-flex flex-wrap">
                {/* links */}
                <div className="links-sec pe-lg-4">
                    <div className="inner">
                        <p className="head st-fw-700 st-fs-17 mb-3">Shipping Policies</p>

                        <a
                            href="ppt1"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt1")}
                        >
                            Shipping Types
                        </a>
                        <a
                            href="ppt2"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt2")}
                        >
                            Backorders & Cancellations
                        </a>
                    </div>
                </div>

                {/* text */}
                <div className="text-sec media-body ps-lg-4">
                    {/* frac */}
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-700 st-fs-17 mb-2">Shipping Types</p>
                        <p className="desc st-fs-15 mb-2">
                            <ul className="ps-3 mb-1">
                                <li className="st-fw-600">
                                    Standard Shipping
                                </li>
                            </ul>
                            We currently offer free Standard Shipping on all our Products. Items in stock usually ship in 7 business days of receiving your order.
                        </p>
                        <p className="desc st-fs-15 mb-2">
                            <ul className="ps-3 mb-1">
                                <li className="st-fw-600">
                                    Expedited or Next Day Shipping
                                </li>
                            </ul>
                            If you require express shipping on your order, please email support@ruhlisticdecor.com, and we would be happy to help you with a quote.
                        </p>
                        <p className="desc st-fs-15 mb-3">
                            <span className="st-fs-12 text-dark st-fw-600">Deliveries to Alaska, Hawaii, US Territories, and Military Addresses (APO/FPO)</span> <br />
                            If shipping to AK, HI, PR or APO/FPO addresses, you will need to request a quote. Please email support@ruhlisticdecor.com, and we would be happy to help you with a quote for your request.
                        </p>
                        <p className="desc st-fs-15 mb-3">
                            <span className="st-fs-12 text-dark st-fw-600">Sales Tax</span> <br />
                            Sales tax on the merchandise total is charged for items shipped to all 48 states and US territories.
                        </p>
                        <p className="desc st-fs-15 mb-3">
                            <span className="st-fs-12 text-dark st-fw-600">International Shipping</span> <br />
                            Our products cannot currently be shipped outside the United States.
                        </p>
                        <p className="desc st-fs-15 mb-3">
                            <span className="st-fs-12 text-dark st-fw-600">Shipping to Multiple Addresses</span> <br />
                            We do not currently offer the ability to ship to multiple addresses.
                        </p>
                        <p className="desc st-fs-15 mb-3">
                            <span className="st-fs-12 text-dark st-fw-600">Shipping to a PO Box</span> <br />
                            We do not currently offer the ability to ship to a PO Box.
                        </p>
                    </div>

                    {/* frac */}
                    <div className="frac mb-3" id="ppt2">
                        <p className="head st-fw-700 st-fs-17 mb-2">Backorders & Cancellations</p>
                        <p className="desc st-fs-15 mb-2">
                            <ul className="ps-3 mb-1">
                                <li className="st-fw-600">
                                    Standard Shipping
                                </li>
                            </ul>
                            We currently offer free Standard Shipping on all our Products. Items in stock usually ship in 7 business days of receiving your order.
                        </p>
                        <p className="desc st-fs-15 mb-4">
                            Ruhlistic Decor strives to have every product in stock and available to ship. If an item is not available for immediate shipment, it will be backordered and will ship automatically once it comes back to stock. If you would like to cancel a backorder, please email support@ruhlisticdecor.com, and we would be happy to help you.
                        </p>
                        <p className="desc st-fs-15 mb-1">
                            **please note that you will not be charged for backordered items until they ship.
                        </p>
                        <p className="desc st-fs-15 mb-2">
                            **If your backorder is under $50 or older than 6 months, we reserve the right to cancel.
                        </p>
                    </div>


                </div>
            </div>
        </div>
    )
}
